// Module
var code = `<fieldset ng-disabled="form.readonly" class="schema-form-fieldset {{form.htmlClass}}">
  <legend ng-class="{'sr-only': !showTitle() }">{{ form.title }}</legend>
  <div class="help-block" ng-show="form.description" ng-bind-html="form.description"></div>
</fieldset>
`;
// Exports
module.exports = code;